import React from 'react';
import { dadosGeraisState } from '../atoms';
import { useRecoilState } from 'recoil';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import WidgetIntegracaoContrato from './WidgetIntegracaoContrato';
import WidgetHistoricoAprovacoes from './WidgetHistoricoAprovacoes';
import { WidgetInfoAprovacaoExpectativaTotvs } from './WidgetInfoAprovacaoExpectativaTotvs';
import { Visibility } from '@app/components';
import { ETipoContrato } from '@app/enums/ETipoContrato';

interface Props {
  parteDoFluxo?: boolean;
  ehComprador?: boolean;
}

const AbaIntegracaoContrato = ({ parteDoFluxo = false, ehComprador = false }: Props) => {
  const [dadosGerais] = useRecoilState(dadosGeraisState);
  const aditivo = dadosGerais.tipo === ETipoDemanda.Aditivo;
  const ehPCS = (dadosGerais.modalidadeContratoTotvs || '').toLocaleLowerCase() === ETipoContrato.PCS;
  
  return (
    <>
      <WidgetIntegracaoContrato parteDoFluxo={parteDoFluxo || aditivo} ehComprador={ehComprador} />
      {
        (!aditivo || ehPCS) && <WidgetHistoricoAprovacoes parteDoFluxo={parteDoFluxo} />
      }

      <Visibility visible={ehPCS && !aditivo}>
        <WidgetInfoAprovacaoExpectativaTotvs parteDoFluxo={parteDoFluxo} />
      </Visibility>
    </>
  );
};

export default AbaIntegracaoContrato;
